import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router";
import { ModalOxxoType } from "../../../components/common/ModalOxxoType";
import { imgs } from "../../../assets/imgs";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialog1: 1,
	dialog2: 2,
	dialog3: 3,
	dialog4: 4,
	dialog5: 5,
	panel_OXXO_PARADA_TECNICA: 6,
	panel_OXXO_OFICINA: 7,
	panel_OXXO_HOGAR_REUNION: 8,
	panel_OXXO_CLASICO: 9,
	panel_OXXO_BARRIO: 10,
	dialog6: 11,
	dialog7: 12,
	dialogFinal: 13,
	moveHidden: 1000,
	dialog2Extra: 14
};


const stepsCity = {
	OXXO_HOGAR_REUNION001: steps.panel_OXXO_PARADA_TECNICA,
	OXXO_OFICINA: steps.panel_OXXO_OFICINA,
	OXXO_HOGAR_REUNION: steps.panel_OXXO_HOGAR_REUNION,
	OXXO_CLASICO: steps.panel_OXXO_CLASICO,
	OXXO_BARRIO: steps.panel_OXXO_BARRIO,
};

const selectOxxo = [
	{
		id: 1,
		name: "Oficinista",
		img: imgs.oficinistas3,
	},
	{
		id: 2,
		name: "Parada técnica",
		img: imgs.paradaTecnica3,
	},
	{
		id: 3,
		name: "Hogar/Reunión",
		img: imgs.hogarReunion3,
	},
	{
		id: 4,
		name: "Barrio competido",
		img: imgs.barrioCompetido3,
	},
	{
		id: 5,
		name: "Clásico",
		img: imgs.oxxoclasico3,
	}
]

export const SubtopicOneActivityThree = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialog1);
	const [selectStateOxxo, setSelectStateOxxo] = useState(-1)

	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema1], 3);


	useEffect(() => {
		if (loaded) {
			console.log("subtema one Activity one");
			ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.cityScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act3_a01)
	})

	const closeModalnfo = (number = 0) => {
		switch (number) {
			case stepsCity.OXXO_BARRIO:
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.moveStore2)
				break;
			case stepsCity.OXXO_HOGAR_REUNION001:
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.moveStore5)
				break;
			case stepsCity.OXXO_CLASICO:
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.upTower)
				break;
			case stepsCity.OXXO_HOGAR_REUNION:
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.moveStore4)
				break;
			case stepsCity.OXXO_OFICINA:
				ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.moveStore3)
				break;
			default:
				break;
		}
	};

	ObserverEmitter.on(EVENTS.subtopicOne.activityThree.upTowerShowMessage, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act3_a04)
		setUiToShow(steps.dialog6);
	});

	ObserverEmitter.on(EVENTS.subtopicOne.activityThree.backClick, (name) => {
		const nameSelect = stepsCity[name]
		if (!nameSelect) {
			return
		}
		setUiToShow(nameSelect)
	})

	ObserverEmitter.on(EVENTS.subtopicOne.activityThree.showHelpDialog, () => {
		setUiToShow(steps.dialogHelper);
	});

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, steps.moveHidden].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 3);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialog1 && (
				<>
					<HeaderRedPresentation name="Actividad 1: Tipos de tienda." />
					<DialogBarNew
						dialog={`Espero hayas disfrutado el recorrido por cada área dentro de la tienda. ¿Sabías que las Tiendas OXXO son colocadas de manera estratégica e las necesidades de los consumidores?`}
						percentage={"20%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act3_a02)
							setUiToShow(steps.dialog2Extra);
						}}
					></DialogBarNew>
				</>

			)}
			{uiToShow === steps.dialog2Extra && (
				<>
					<HeaderRedPresentation name="Actividad 1: Tipos de tienda." />
					<DialogBarNew
						dialog={`A continuación veremos la clasificación por segmentos de los tipos de Tiendas OXXO y las características de estas. ¡Al final podras reconocer a la que perteneces!`}
						percentage={"20%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.dialog2);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						}}
					></DialogBarNew>
				</>

			)}
			{uiToShow === steps.dialog2 && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Imagen en la tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialog3);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialog3 && (
				<>
					<PanelInstrucionHands
						text="Toca encima de las tiendas Oxxo para obtener información."
						action={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act3_a03)
							setUiToShow(steps.dialog5);
							ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.initActivityMovement);
						}}
						img={imgInstruction.sub1_act_3_001}
					/>
				</>
			)}
			{uiToShow === steps.dialog5 && (
				<>
					<DialogBarNew
						dialog={`Es importante conocer las características  de dónde reside cada una de las tiendas, observa a detalle cada uno de los entornos que rodea a cada tipo de tienda.`}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.moveHidden);
							ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.moveStore1)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.moveHidden && (<></>)}

			{
				[
					steps.dialog5,
				].includes(uiToShow) && (
					<BarStatusActivies activities={tasksList} />
				)
			}

			{uiToShow === steps.panel_OXXO_OFICINA && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalOxxoType
						imgOne={imgs.oficinistas}
						imgTwo={imgs.oficinistas2}
						callback={() => {
							setUiToShow(steps.moveHidden);
							closeModalnfo(steps.panel_OXXO_OFICINA);
						}}
					></ModalOxxoType>
				</>
			)}
			{uiToShow === steps.panel_OXXO_BARRIO && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalOxxoType
						imgOne={imgs.barrioCompetido1}
						imgTwo={imgs.barrioCompetido2}
						callback={() => {
							setUiToShow(steps.moveHidden);
							closeModalnfo(steps.panel_OXXO_BARRIO);
						}}
					></ModalOxxoType>
				</>
			)}
			{uiToShow === steps.panel_OXXO_CLASICO && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalOxxoType
						imgOne={imgs.oxxoclasico1}
						imgTwo={imgs.oxxoclasico2}
						callback={() => {
							setUiToShow(steps.moveHidden);
							closeModalnfo(steps.panel_OXXO_CLASICO);
						}}
					></ModalOxxoType>
				</>
			)}
			{uiToShow === steps.panel_OXXO_HOGAR_REUNION && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalOxxoType
						imgOne={imgs.hogarReunion1}
						imgTwo={imgs.hogarReunion2}
						callback={() => {
							setUiToShow(steps.moveHidden);
							closeModalnfo(steps.panel_OXXO_HOGAR_REUNION);
						}}
					></ModalOxxoType>
				</>
			)}
			{uiToShow === steps.panel_OXXO_PARADA_TECNICA && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ModalOxxoType
						imgOne={imgs.paradaTecnica1}
						imgTwo={imgs.paradaTecnica2}
						callback={() => {
							setUiToShow(steps.moveHidden);
							closeModalnfo(steps.panel_OXXO_PARADA_TECNICA);
						}}
					></ModalOxxoType>
				</>
			)}

			{uiToShow === steps.dialog6 && (
				<>
					<HeaderRedPresentation name="Actividad 1: Tipos de tienda." />
					<DialogBarNew
						dialog={`Ahora que conoces todos los segmentos maestros que maneja OXXO, ¿A que tipo de tienda consideras que perteneces?`}
						percentage={"80%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.dialog7);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.subtopicOne.activityThree.initActivityMovement)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog7 && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<HeaderRedPresentation name="¿A qué tipo de tienda perteneces?" />
					<div className="fixed z-30 bottom-0 h-full w-full flex justify-center items-center px-8 md:px-[65px] ">
						<div className="w-full h-[160px] md:h-[230px] gradiantBlueClient rounded-[32px] border-[1px] border-white overflow-hidden p-3 md:p-4 grid grid-cols-5 gap-4">
							{selectOxxo.map((oxxo, index) => (
								<div key={`${index}-oxxo`} onClick={() => {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoInformacion)
									setSelectStateOxxo(oxxo.id)
								}} className="h-full w-full rounded-[32px] overflow-hidden">
									<div className={`h-full w-full rounded-[32px] border-[10px] ${selectStateOxxo === oxxo.id ? "border-yellow_primary" : "border-[#ffffffa3]"}`}>
										<div className="w-full h-full border-[4px] border-white rounded-[20px] overflow-hidden bg-white">
											<div className="h-[75%] w-full">
												<div className="h-full w-full">
													<img className="h-full w-full " src={oxxo.img} alt="oxxo" />
												</div>
											</div>
											<div className="h-[25%] w-full bg-white flex justify-center items-center">
												<span className="text-black font-bold text-[10px]">{oxxo.name}</span>
											</div>
										</div>
									</div>

								</div>
							))}
						</div>
					</div>
					<div onClick={() => {
						if (selectStateOxxo === -1) {
							return
						}
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
						localStorage.setItem("oxxoTienda", selectStateOxxo)
						setUiToShow(steps.dialogFinal);
					}} className="boxShadowButtons fixed z-30 bottom-3 right-4 h-[40px] w-[184px] md:h-[48px] md:w-[268px] rounded-2xl bg-yellow_primary flex justify-center items-center">
						<span className="text-white text-[20px] md:text-[24px]">Continuar</span>
					</div>
				</>
			)}
			{uiToShow === steps.dialogFinal && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Consulta a qué tipo de segmento tu Tienda OXXO pertenece con tu Líder o Asesor de Tienda."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: 0,
									subtema: tasksId.tema1.activities.subtema1,
								})
							);
							navigator("/home1/tema1/subtema1/activityfour");
						}}
					/>
				</>
			)}
		</>
	);
};
